<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-08-14 15:18:49
-->
<template>
  <el-dialog @close="close" :visible="visible" :close-on-click-modal="false" width="600px" center append-to-body>
    <div class="login-title">
      <div class="title">{{$t('GA.login')}}</div>
      <div class="msg">{{$t('GA.loginMsg')}}</div>
    </div>
    <div class="form-box">
      <el-form :model="form" ref="form" label-width="130px" :rules="rules" label-position="top">
        <el-form-item prop="email" :label="$t('GA.Email') + ':'" required>
          <el-input v-model="form.email" @keyup.enter.native="loginFun"></el-input>
        </el-form-item>
        <el-form-item prop="userPassword" :label="$t('GA.password') + ':'" required>
          <el-input type="password" v-model="form.userPassword" @keyup.enter.native="loginFun"></el-input>
        </el-form-item>
        <el-form-item prop="userPassword" :label="$t('GA.verifyCode') + ':'" required>
          <div class="valideCodecontent">
            <el-input v-model="form.code" style="margin-right: 20px;"></el-input>
            <img :src="valideCode" alt class="valideCodeImge" @click="getcode" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loginFun" class="btn">{{$t('login')}}</el-button>
      </span>
      <div class="operation">
        <div>
          <span style="cursor: pointer;color: #666666;" @click="resetPass">{{$t('GA.ForgetPassword')}}</span>
        </div>
        <div>
          <span style="cursor: pointer;color:#FF0000;" @click="register">{{ $hs("立刻注册",'Register') }}</span>
        </div>
      </div>
    </div>
    <reset-pass-model ref="resetPassModel"></reset-pass-model>
  </el-dialog>
</template>
<script>
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import { mapActions, mapState } from 'vuex'
import { LoginMemberMemberWeb, GetValideCode } from '@/api/login'
export default {
  name: 'loginModal',
  components: {
    resetPassModel
  },
  data() {
    return {
      visible: false,
      codeData: {},
      form: {
        email: '',
        userPassword: '',
        isAudit: false,
        code: '',
        keyCode: 0
      },
      valideCode: "",
      rules: {}
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    open() {
      this.visible = true
      this.getcode();
    },
    getcode() {
      GetValideCode().then(res => {
        if (res.success) {
          this.valideCode = res.data.valideCode
          this.form.keyCode = res.data.keyCode
        }
      })
    },
    close() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    resetPass() {
      this.$refs.resetPassModel.open()
    },
    register() {
      this.close()
      this.$emit('register')
    },

    // 登录
    loginFun() {
      let _this = this
      this.$refs.form.validate(values => {
        if (!values) return false
        LoginMemberMemberWeb({
          userAccount: this.form.email,
          userPassword: this.form.userPassword,
          keyCode: this.form.keyCode,
          valideCode: this.form.code
        })
          .then(res => {
            if (res.success) {
              _this.set_userInfo(res.data)
              _this.$message.success(
                _this.$hs(
                  '登录成功',
                  'Login succeeded',
                  'Inicio de sesión exitoso'
                )
              )
              _this.close()
              _this.$router.push('/home')
              window.location.reload() // 强刷界面
            }
          })
          .catch(err => {
            if (err.includes('D1632') || err.includes('D1631')) {
              _this.$message.error(_this.$t('CodeError'))
            } else if (err.includes('D1629')) {
              _this.$message.error(_this.$t('notreviewed'))
            } else if (err.includes('D1628')) {
              _this.$message.error(_this.$t('loginError'))
              _this.getcode();
            }
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .login-title {
    height: 88px;
    text-align: left;
    margin-left: 30px;
    .title {
      height: 62px;
      line-height: 62px;
      font-size: 24px;
      color: #222222;
      font-weight: 700;
    }
    .msg {
      font-size: 14px;
      color: #999999;
    }
  }

  .form-box {
    margin-top: 40px;
    padding: 0 30px;
  }

  .operation {
    padding: 0 0px 30px;
    font-size: 14px;
    color: #222222;
    display: flex;
    justify-content: space-between;
  }
}
:deep .el-form {
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  box-sizing: border-box;
  .btn {
    flex: 1;
    margin-bottom: 10px;
    margin-top: 20px;
    background-color: #ff0000;
    border-color: #ff0000;
  }
}

:deep(.el-form-item__error) {
  display: none;
}

:deep(.el-form-item) {
  margin-bottom: 15px;
}

:deep(.el-form-item__label) {
  padding: 0;
}
.valideCodecontent {
  display: flex;
  justify-content: space-between;
  .valideCodeImge {
    border: 1px solid #e5e5e5;
    cursor: pointer;
  }
}
</style>